import { useCallback, useEffect, useRef } from 'react';

import { type UseCloseOnEscapeProps } from './types';

export const useCloseOnEscapePress = ({ onClose, isDisabled }: UseCloseOnEscapeProps): void => {
	const escapePressed = useRef(false);

	const onKeyDown = useCallback(
		(e: KeyboardEvent) => {
			if (isDisabled || escapePressed.current || e.key !== 'Escape') {
				return;
			}

			escapePressed.current = true;
			onClose(e);
		},
		[onClose, isDisabled],
	);

	const onKeyUp = useCallback(() => {
		escapePressed.current = false;
	}, []);

	useEffect(() => {
		document.addEventListener('keydown', onKeyDown);
		document.addEventListener('keyup', onKeyUp);

		return () => {
			document.removeEventListener('keydown', onKeyDown);
			document.removeEventListener('onKeyUp', onKeyUp);
		};
	}, [onKeyDown, onKeyUp]);
};
